module.exports = __webpack_public_path__ + "static/img/main-navigation-icon06.453ddbca.svg";